<template>
  <div>
 
 


 


<!--
  
   <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>

-->



 

<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;box-shadow:rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div
 
v-bind:class="[{ botactive: $route.path.toLowerCase()=='/'+info.name.toLowerCase()},{ botnotactive: $route.path.toLowerCase()!='/'+info.name.toLowerCase() },{navclass:true}]"  >


    <router-link to='/' style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botnotactive navclass"   style="position:relative">
    <router-link to='/bag'  style='text-decoration:none'>

<div style="width:16px;height:16px;background:#EB3838;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagbottom.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div   class="botactive navclass"   v-on:click='account'>
        

 <img src="./images/files/userwhite.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>


<!--headerr--> 

 




  

  

<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper d-flex" style=" background:#fff;z-index:10000000">
  <div class="container pad  " >

  <div class="headerui     ">
 <router-link  to='/' style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
  
  <img src="./images/finallogo.png" style="" class="logohigh">
</div>
</router-link>




<div style="position:fixed;top:0;left:0;right:0;bottom:0px;background:rgba(0,0,0,0.3);z-index:100000000;cursor:pointer"  class="d-md-block d-none" v-if='opacitybox'  v-on:click='opacitybox=false' ></div>


 







<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>
 
  <router-link    to="/bag"  style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>
   <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>


</div>

</div>

  </div>
  
</div>















  <div >









 

<div  v-if='loadstatus && theme==3' >

</div>


<div  v-else-if='loadstatus && theme==2' >






 

</div>



<div v-else-if='loadstatus && theme==1' >










 

<div class="pt-md-4 pb-md-5 pt-0 pb-3  headerwrapper2  " style="background:#fff!important">
  <div class="container pads "  >




<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 m17" >
  
  <svg class='d-none' width="21"   height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>

<p  class="shopbag" style="margin-left:0px;margin-top:0px!important" >Order #{{actualorders[0].orderid}}
</p>


</div>

  <div class="   ">





<div class="row justify-content-start" style="margin:0px">
  
  <div class="col-md-8 mobcol" style="padding:0px" >

    <div style="padding:0px" class="cartborder">




 

<div class="   d-md-flex d-none  justify-content-between paditemslen  " style=" ">
  
  <p class="categorytextcat   itemslength" style=""  >{{rendercartlength}} Items</p>
  <p class="categorytextcat  "  style="font-family: 'Montserrat', sans-serif;font-size:14px;font-weight:700" ><span style="" class="totaltext">Total: </span> 



    <span  class="itmtotal totalvals" v-if="actualorders[0].deliveryamount!='Free' &&  actualorders[0].couponapplied.status"      id="totalpay">₹{{ actualorders[0].total+ actualorders[0].deliveryamount-Number(actualorders[0].couponapplied.discountamount)}}</span>
       <span  class="itmtotal totalvals" v-else-if="actualorders[0].deliveryamount!='Free' "    id="totalpay">₹{{ Number(actualorders[0].total)}}</span>


         <span  class="itmtotal totalvals" v-else     id="totalpay">₹{{ actualorders[0].total}}</span>




       </p>
 
</div>



      
      <div v-if=' actualorders!=null' style="" class="pad25">
          

           <template v-for='a in actualorders[0].items '>
       
      <div class="d-flex align-items-center  mb-4">
        <div style="width:55px;border-radius:5px;overflow:hidden"  >
          <img :src="a.imageurl" class="img-fluid">
        </div>

        <div style="flex: 1;padding: 5px 13px;padding-right:0px" class="d-flex align-items-center flex-wrap">
          <div style="width:100%!important" >
             <p   class="aname" >{{a.name}}</p>
             <p style="margin-bottom:10px">Varient: ({{rendervarient(a.vaientid,a.varients)}})</p>
          </div>
         
 

          <div class=" ml-auto" style="text-align:right">
            <div class="d-flex align-items-center " style="margin-bottom:5px">
             


      
                 <p  style="" class="aquantity">{{a.quantity}}</p>
           
 
       <i class='bx bx-x  ax ' style=""  ></i>

      <span style="" class="aprice"  v-if='a.deals'>₹{{a.offerprice}}.0</span>
       <span  class="aprice" v-else>₹{{a.actprice}}.0</span>


            </div>

            

            <span class="mt-2 atprice" style=""      >₹{{a.price}}.0</span>
          </div>
        </div>
        
      </div>      
    </template>





                  <div style="height: 1px;background:  rgba(231, 231, 246, 0.5);margin-top: 20px;"></div>


   <div v-if="actualorders[0].status=='Rejected'" class="d-flex align-items-center py-1 mt-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#E50B20" class="mr12"><path d="M32.7 26.014l-.001-.001c-2.197-4.506-5.88-10.898-9.129-16.537-1.7-2.951-3.306-5.738-4.467-7.857C18.555.62 17.582.021 16.5.021c-1.082 0-2.056.598-2.603 1.598-1.162 2.12-2.769 4.91-4.47 7.863C6.177 15.12 2.496 21.509.3 26.014c-.2.41-.301.844-.301 1.29 0 1.636 1.322 2.968 2.948 2.968L16.5 30.27l13.552.002c1.626 0 2.948-1.332 2.948-2.969 0-.445-.101-.88-.3-1.29zm-2.647 2.883H2.949a1.586 1.586 0 01-1.411-2.281c2.175-4.462 5.844-10.83 9.08-16.447 1.705-2.96 3.316-5.757 4.484-7.889a1.593 1.593 0 012.796 0c1.167 2.131 2.777 4.925 4.48 7.882 3.239 5.62 6.909 11.99 9.085 16.453a1.586 1.586 0 01-1.41 2.282z"></path><path d="M16.5 6.897a.688.688 0 00-.688.688v13.75a.687.687 0 001.376 0V7.585a.688.688 0 00-.688-.688z"></path><circle cx="16.5" cy="25.459" r="1.158"></circle></svg>
                    <div class="pl-4" style="padding-left:20px">
                      <p style="color:#e50b20;font-weight: 400;font-size: 14px;" class=" ">Order Rejected</p>
                      <p style="color:#808080;font-weight:300;font-size:12px" class="mt-1">Today, {{actualorders[0].rejectedtime}}</p>
                      
                    </div>
                   


                  </div>


   <div v-if="actualorders[0].status=='Cancelled'" class="d-flex align-items-center py-1 mt-4">
              

                  <i class='bx bxs-error' style="font-size:35px;color:#E50B20;margin-right:20px"></i>


                    <div class="pl-md-4 pl-5 ml-5">
                      <p style="color:#e50b20;font-weight: 500;font-size: 19px;" class=" ">Order Cancelled</p>
                    
                      
                    </div>
                   


                  </div>



   <div v-if="actualorders[0].status=='Not Delivered'" class="d-flex align-items-center py-1 mt-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#E50B20" class="mr12"><path d="M32.7 26.014l-.001-.001c-2.197-4.506-5.88-10.898-9.129-16.537-1.7-2.951-3.306-5.738-4.467-7.857C18.555.62 17.582.021 16.5.021c-1.082 0-2.056.598-2.603 1.598-1.162 2.12-2.769 4.91-4.47 7.863C6.177 15.12 2.496 21.509.3 26.014c-.2.41-.301.844-.301 1.29 0 1.636 1.322 2.968 2.948 2.968L16.5 30.27l13.552.002c1.626 0 2.948-1.332 2.948-2.969 0-.445-.101-.88-.3-1.29zm-2.647 2.883H2.949a1.586 1.586 0 01-1.411-2.281c2.175-4.462 5.844-10.83 9.08-16.447 1.705-2.96 3.316-5.757 4.484-7.889a1.593 1.593 0 012.796 0c1.167 2.131 2.777 4.925 4.48 7.882 3.239 5.62 6.909 11.99 9.085 16.453a1.586 1.586 0 01-1.41 2.282z"></path><path d="M16.5 6.897a.688.688 0 00-.688.688v13.75a.687.687 0 001.376 0V7.585a.688.688 0 00-.688-.688z"></path><circle cx="16.5" cy="25.459" r="1.158"></circle></svg>
                    <div class="pl-4" style="padding-left:20px">
                      <p style="color:#e50b20;font-weight: 400;font-size: 14px;" class=" ">Failed</p>
                      <p style="color:#808080;font-weight:300;font-size:12px" class="mt-1">Today, {{actualorders[0].notdeliveredtime}}</p>
                      
                    </div>
                   


                  </div>



<div class="d-flex flex-wrap  align-items-center justify-content-between mt-4">
      <div    class="d-flex align-items-center mb-md-0 mb-4  " style="background:rgb(236 235 244 / 40%);padding:11px 25px;border-radius:5px; cursor:pointer;margin-right:15px">

          
 <a  :href='actualorders[0].orderlink' target="_blank" style=" font-weight: 500;
font-size: 14px;
margin-left:8px;
  
color: #696979;text-decoration:none"  class="d-block" >Track</a>

          


</div>


  <div    class="d-flex align-items-center mb-md-0 mb-4  " style="background:rgb(236 235 244 / 40%);padding:11px 25px;border-radius:5px; cursor:pointer;margin-right:15px">

          
 <router-link to='/contact'  style=" font-weight: 500;
font-size: 14px;
margin-left:8px;
  
color: #696979;text-decoration:none"  class="d-block" >Need Help!</router-link>

          


</div>


  <p style="text-align:center;color:#333;font-weight:400;font-size17px;width:100%;margin-top:20px">Note: Please mention your order number to cancel or modify the order</p>
 

 <div class="  d-none    justify-content-between  " style=" border:none!important;position:relative;width:400px">
  <div style="position:absolute;top:30% ; left:40px;right:40px;height:2px;background:#FFB13B "></div>


  <div class="d-flex  flex-column align-items-center  " v-on:click="tab='bag'" style="cursor:pointer;background:#fff">
    <div style="width:40px;height:40px;background: #FFB13B;position:relative;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">1</p>
    </div>
    <p class='mt-1'>Confirmed</p>
   </div> 
 

 



   <div class="d-flex flex-column align-items-center  "  style="cursor:pointer" v-if="actualorders[0].status=='Shipped'"  v-on:click="tab='address'">
    <div style="width:40px;height:40px;background: #FFB13B;position:relative;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">2</p>
    </div>
        <p class='mt-1'>Shipped</p>
   </div> 




   <div class="d-flex flex-column align-items-center  " v-if="actualorders[0].status!='Shipped'"  >
    <div style="width:40px;height:40px;background: #fff;position:relative;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700">2</p>
    </div>
        <p class='mt-1'>Shipped</p>
   </div> 



 

   <div class="d-flex flex-column align-items-center  "  style="cursor:pointer"  v-if="actualorders[0].status=='Delivered'"   v-on:click="tab='paymentmode'" >
    <div style="width:40px;height:40px;background: #FFB13B;position:relative;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">3</p>
    </div>
        <p class='mt-1'>Delivered</p>
   </div> 



   <div class="d-flex flex-column align-items-center  "  v-if="actualorders[0].status!='Delivered'"  >
    <div style="width:40px;height:40px;background: #fff;position:relative;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700;font-weight:700">3</p>
    </div>
        <p class='mt-1'>Delivered</p>
   </div> 




 
</div>


</div>


<div style="position:relative;display:none" v-if="actualorders[0].status!='Rejected' || actualorders[0].status!='Cancelled' ">



                  <div v-if="actualorders[0].status=='pending'" class="d-flex align-items-start pt-3 mt-3 pb-0">
             <svg width="24" style='min-width:24px' height="24" viewBox="0 0 24 24" class='mr12' fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path d="M22 2V22H2V2H22ZM24 0H0V24H24V0ZM18 10V18H10V10H18ZM20 8H8V20H20V8ZM4 4V16H6V6H16V4H4Z" fill="#0B0A23"/>
</g>
</svg>


                    <div class="pl-4 d-flex flex-wrap align-items-center justify-content-between" style="flex:1;padding-left:20px">
                      <div style="    margin-top: -4px;">
                        
                      <p style="" class="orderpen ">Order Pending</p>

                      <p style="line-height:20px;" class="mt-1  shortext" >Your order is successful and seller will confirm your order shortly.</p>
</div>
 <div style="cursor:pointer;font-weight: 600;
font-size: 15px;
 

text-align: center;

color: #EB3838;" class="mt-md-2 mt-4 cancelbtn" v-on:click='cancelorder'>Cancel Order</div>
                     
                    </div>


                  </div>


                    <div v-if="actualorders[0].status=='Accepted' || actualorders[0].status=='Shipped' || actualorders[0].status=='Delivered'" class="d-flex align-items-start py-3 mt-3">


                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="gray" stroke="gray" class="mr12"><g stroke-width=".3" fill-rule="evenodd">
                      <path d="M18 1.5c.69 0 1.658.172 2.539.464.44.146.853.319 1.189.54.298.198.576.463.634.817l.011.137v1.044h3.356c.253.005.46.17.498.382l.006.081V6.77h4.49c.78 0 1.444.524 1.52 1.2l.007.127v24.636c0 .692-.618 1.257-1.381 1.32l-.145.007H5.276c-.78 0-1.443-.524-1.519-1.199l-.007-.128V8.096c0-.692.618-1.257 1.381-1.32l.145-.007h4.49V4.958c0-.223.181-.409.422-.449l.093-.007h3.346V3.458c0-.424.31-.731.645-.953.336-.222.749-.395 1.189-.541.881-.292 1.849-.464 2.54-.464zM5.276 7.668c-.25 0-.45.148-.491.348l-.008.078v24.635c0 .212.172.373.408.406l.09.006h5.988l13.473.002h5.988c.25 0 .45-.137.49-.335l.008-.077V8.095c0-.212-.171-.383-.407-.418l-.091-.007h-4.477v1.817a.417.417 0 01-.088.245.415.415 0 01-.073.078.554.554 0 01-.212.112l-.082.016H10.178l-.015-.006h0l-.015-.007h-.014l-.015-.006h0l-.015-.006h-.015l-.021-.006h0l-.022-.007h-.015l-.015-.013h0l-.014-.013h-.015l-.015-.012h0l-.015-.013h-.014l-.008-.013h0l-.007-.013h-.015a.445.445 0 01-.155-.26l-.006-.075V7.671H5.276v-.003zM18 2.402c-.461 0-1.425.16-2.187.412-.38.126-.716.274-.924.412-.21.139-.235.239-.235.232h0v1.507c-.002.249-.23.45-.514.451h0-3.346v1.805h0v1.804h14.412V5.417H21.86c-.283-.002-.512-.203-.514-.452h0V3.458c0 .007-.026-.093-.235-.232-.208-.138-.543-.286-.924-.412-.762-.253-1.726-.412-2.187-.412h0z"></path><path d="M9.817 25.737c.518 0 .944.414.944.932s-.426.943-.944.943c-.517 0-.931-.425-.931-.943s.414-.932.931-.932zm16.973.338c.284.004.513.267.516.594.003.331-.228.603-.516.606h0-13.306c-.288-.003-.519-.275-.516-.606.003-.331.239-.597.526-.594h0zM9.817 20.3c.518 0 .944.413.944.931s-.426.944-.944.944c-.517 0-.931-.426-.931-.944s.414-.931.931-.931zm16.973.337c.284.004.513.268.516.595.003.33-.228.602-.516.605h0-13.296c-.283-.003-.513-.267-.515-.593-.003-.332.228-.603.515-.607h0zM9.817 14.85c.518 0 .944.426.944.944s-.426.931-.944.931c-.517 0-.931-.413-.931-.931s.414-.944.931-.944zm3.648.35H26.79c.284.004.513.268.516.594.003.33-.228.602-.516.605h0-13.296c-.287.018-.534-.235-.55-.566-.016-.33.204-.614.492-.632h.058z"></path></g>
                    </svg>
                    <div class="pl-4" style="padding-left:20px">
                      <p style="color:#1a181e;font-weight: 600;font-size: 16px;" class=" ">Order Confirmed</p>
                      <p style="" class="mt-1 todaytxt">Today, {{actualorders[0].acceptedtime}}</p>
                      
                    </div>

                    <div style="" class="align-self-center ml-auto donetxt">
                      Done
                    </div>


                  </div>




                     <div v-if="actualorders[0].status=='Accepted'" class="d-flex align-items-start py-3 mt-0">
              <svg width="28" height="28" viewBox="0 0 28 28" class='mr12' fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.83333 12.8333V14H15.1667V5.83333H3.5V4.66667C3.5 4.02267 4.02267 3.5 4.66667 3.5H16.3333C16.9773 3.5 17.5 4.02267 17.5 4.66667V7H22.9448C24.248 7 24.8115 7.672 25.2035 8.2915C25.8965 9.38817 26.9955 11.1288 27.664 12.2325C27.8833 12.5965 28 13.0142 28 13.44V18.6667C28 19.9372 27.1332 21 25.6667 21H24.5C24.5 22.932 22.932 24.5 21 24.5C19.068 24.5 17.5 22.932 17.5 21H12.8333C12.8333 22.932 11.2653 24.5 9.33333 24.5C7.40133 24.5 5.83333 22.932 5.83333 21H4.66667C4.02267 21 3.5 20.4773 3.5 19.8333V12.8333H1.16667V10.5H9.33333V12.8333H5.83333ZM9.33333 19.6C10.1057 19.6 10.7333 20.2277 10.7333 21C10.7333 21.7723 10.1057 22.4 9.33333 22.4C8.561 22.4 7.93333 21.7723 7.93333 21C7.93333 20.2277 8.561 19.6 9.33333 19.6ZM21 19.6C21.7723 19.6 22.4 20.2277 22.4 21C22.4 21.7723 21.7723 22.4 21 22.4C20.2277 22.4 19.6 21.7723 19.6 21C19.6 20.2277 20.2277 19.6 21 19.6ZM17.5 16.3333H5.83333V18.6667H6.72583C7.36633 17.9503 8.29733 17.5 9.33333 17.5C10.3693 17.5 11.3003 17.9503 11.9408 18.6667H18.3925C19.033 17.9503 19.964 17.5 21 17.5C22.036 17.5 22.967 17.9503 23.6075 18.6667H25.6667V13.3292L23.6705 9.912C23.4617 9.55383 23.0778 9.33333 22.6637 9.33333H17.5V16.3333ZM18.6667 10.5V14H24.5L22.8352 11.088C22.6275 10.724 22.2413 10.5 21.8225 10.5H18.6667ZM0 7H9.33333V9.33333H0V7Z" fill="#0B0A23"/>
</g>
</svg>

                    <div class="pl-4" style="flex:1;padding-left:20px">
                      <p style="font-weight: 600;
font-size: 15px;
 


color: #8C8E9C;" class=" ">To Be Shipped</p>
                      <p style=" " class="mt-1 statusdesc todaytxt">Your order will be delivered within 30-60 minutes

</p>
                      
                    </div>


                  </div>



                     <div v-if=" actualorders[0].status=='pending'  " class="d-flex align-items-start pt-4 mt-md-0 m pb-0 mt-3 align-items-center">
                   <svg width="28" height="28" viewBox="0 0 28 28" class='mr12' fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.83333 12.8333V14H15.1667V5.83333H3.5V4.66667C3.5 4.02267 4.02267 3.5 4.66667 3.5H16.3333C16.9773 3.5 17.5 4.02267 17.5 4.66667V7H22.9448C24.248 7 24.8115 7.672 25.2035 8.2915C25.8965 9.38817 26.9955 11.1288 27.664 12.2325C27.8833 12.5965 28 13.0142 28 13.44V18.6667C28 19.9372 27.1332 21 25.6667 21H24.5C24.5 22.932 22.932 24.5 21 24.5C19.068 24.5 17.5 22.932 17.5 21H12.8333C12.8333 22.932 11.2653 24.5 9.33333 24.5C7.40133 24.5 5.83333 22.932 5.83333 21H4.66667C4.02267 21 3.5 20.4773 3.5 19.8333V12.8333H1.16667V10.5H9.33333V12.8333H5.83333ZM9.33333 19.6C10.1057 19.6 10.7333 20.2277 10.7333 21C10.7333 21.7723 10.1057 22.4 9.33333 22.4C8.561 22.4 7.93333 21.7723 7.93333 21C7.93333 20.2277 8.561 19.6 9.33333 19.6ZM21 19.6C21.7723 19.6 22.4 20.2277 22.4 21C22.4 21.7723 21.7723 22.4 21 22.4C20.2277 22.4 19.6 21.7723 19.6 21C19.6 20.2277 20.2277 19.6 21 19.6ZM17.5 16.3333H5.83333V18.6667H6.72583C7.36633 17.9503 8.29733 17.5 9.33333 17.5C10.3693 17.5 11.3003 17.9503 11.9408 18.6667H18.3925C19.033 17.9503 19.964 17.5 21 17.5C22.036 17.5 22.967 17.9503 23.6075 18.6667H25.6667V13.3292L23.6705 9.912C23.4617 9.55383 23.0778 9.33333 22.6637 9.33333H17.5V16.3333ZM18.6667 10.5V14H24.5L22.8352 11.088C22.6275 10.724 22.2413 10.5 21.8225 10.5H18.6667ZM0 7H9.33333V9.33333H0V7Z" fill="#0B0A23"/>
</g>
</svg>
                    <div class="pl-4" style="padding-left:20px">
                      <p style="font-weight: 600;
font-size: 15px;
 


color: #8C8E9C;" class=" ">To Be Shipped</p>
                     
                    </div>


                  </div>



  <div v-if="actualorders[0].status=='Shipped' || actualorders[0].status=='Delivered'" class="d-flex align-items-start py-3 mt-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="gray" class="mr12"><path d="M33.687 16.938l-3.432-6.867a1.882 1.882 0 00-1.694-1.041H22.41V7.14a1.89 1.89 0 00-1.89-1.89H4.14a1.89 1.89 0 00-1.89 1.89v18.27a1.89 1.89 0 001.89 1.89h1.94a4.406 4.406 0 008.72 0h6.4a4.406 4.406 0 008.72 0h1.94a1.89 1.89 0 001.89-1.89v-8.19a.742.742 0 00-.063-.282zm-5.126-6.648c.239 0 .457.135.564.348l2.976 5.952H22.41v-6.3h6.151zM9.18 6.51h6.3v5.91l-2.305-1.152a1.902 1.902 0 00-1.69 0L9.18 12.421V6.51zm-5.67 18.9V7.14a.63.63 0 01.63-.63h3.78v5.91a1.26 1.26 0 001.827 1.128l2.305-1.153a.633.633 0 01.563 0l2.304 1.153a1.261 1.261 0 001.821-1.127V6.51h3.78a.63.63 0 01.63.63v18.9H14.8a4.406 4.406 0 00-8.72 0H4.14a.63.63 0 01-.63-.63zm6.93 4.41a3.148 3.148 0 01-2.227-5.377 3.15 3.15 0 112.227 5.377zm15.12 0a3.148 3.148 0 01-2.227-5.377 3.15 3.15 0 112.227 5.377zm6.3-3.78h-1.94a4.402 4.402 0 00-7.51-2.45v-5.74h10.08v7.56a.63.63 0 01-.63.63z"></path><path d="M15.48 21.63h3.78a.63.63 0 100-1.26h-3.78a.63.63 0 100 1.26zm3.78 1.26h-1.89a.63.63 0 100 1.26h1.89a.63.63 0 100-1.26z"></path></svg>
                    <div class="pl-4" style="padding-left:20px">
                      <p style="color: rgb(26, 24, 30);
    font-weight: 600;
    font-size: 16px;" class=" ">Order Shipped</p>
                      <p  class="mt-md-1 todaytxt ">Today, {{actualorders[0].shippedtime}}</p>
                      
                    </div>
                    <div style=" " class="donetxt align-self-center ml-auto">
                      Done
                    </div>


                  </div>







                     <div  v-if="actualorders[0].status=='Shipped'  " class="d-flex align-items-start pt-3 mt-0">
              

                    <svg width="24" class='mr12' height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.5 12C15.464 12 13 14.463 13 17.5C13 20.537 15.464 23 18.5 23C21.535 23 24 20.537 24 17.5C24 14.463 21.535 12 18.5 12ZM11.866 21H0V1H22V10.866C21.38 10.538 20.708 10.294 20 10.15V3H13V9H9V3H2V19H11.15C11.294 19.708 11.538 20.38 11.866 21ZM17.885 18.06L16.626 16.878L15.664 17.867L17.904 20L21.669 16.166L20.69 15.196L17.885 18.06ZM9 17H4V15H9V17Z" fill="#0B0A23"/>
</g>
</svg>
                    <div class="pl-4 " style="flex:1;padding-left:20px">
                      <p style=" font-weight: 600;font-size: 15px;color: #8C8E9C;" class=" ">To Be Delivered</p>
                      <p style=" " class="mt-1 statusdesc">The delivery partner is on his way to deliver your order.</p>
                      
                    </div>


                  </div>


  <div v-if="actualorders[0].status=='Delivered'" class="d-flex align-items-start py-3 mt-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="gray" class="mr12"><path d="M25.563 34.5c-4.928 0-8.938-4.01-8.938-8.938 0-4.928 4.01-8.937 8.938-8.937 4.928 0 8.937 4.01 8.937 8.938 0 4.927-4.01 8.937-8.938 8.937zm0-16.5C21.393 18 18 21.393 18 25.563c0 4.169 3.392 7.562 7.563 7.562 4.17 0 7.562-3.393 7.562-7.563 0-4.169-3.392-7.562-7.563-7.562z"></path><path d="M24.188 29a.697.697 0 01-.487-.2l-2.75-2.75a.688.688 0 01.972-.973l2.23 2.23 4.329-4.947a.684.684 0 01.97-.064c.286.25.315.683.065.969l-4.813 5.5a.692.692 0 01-.495.235h-.021zm-9.625 0H4.937a2.065 2.065 0 01-2.062-2.063V11.813c0-.379.308-.687.688-.687h23.375c.379 0 .687.308.687.688v2.832a.688.688 0 11-1.375 0V12.5h-22v14.438c0 .378.308.687.688.687h9.624a.688.688 0 110 1.375z"></path><path d="M18.688 16.625h-6.875a.688.688 0 110-1.375h6.874a.688.688 0 110 1.375zm9.625-4.125H2.188a.687.687 0 01-.688-.688v-5.5c0-.379.308-.687.688-.687h26.125c.379 0 .687.308.687.688v5.5a.688.688 0 01-.688.687zM2.875 11.125h24.75V7H2.875v4.125z"></path><path d="M28.313 7a.692.692 0 01-.487-.2l-3.923-3.925H6.597L2.674 6.799a.688.688 0 01-.972-.972l4.125-4.125a.68.68 0 01.486-.202h17.875c.182 0 .357.073.486.2L28.8 5.827a.688.688 0 01-.486 1.174z"></path></svg>
                    <div class="pl-4" style="padding-left:20px">

                        <p style="color: rgb(26, 24, 30);
    font-weight: 600;
    font-size: 16px;" class=" ">Order Delivered</p>
                      <p  class="mt-md-1 todaytxt ">Today, {{actualorders[0].deliveredtime}}</p>


                    </div>
                    <div style=" " class="donetxt align-self-center ml-auto">
                      Done
                    </div>


                  </div>


  <div v-if=" actualorders[0].status=='pending' || actualorders[0].status=='Accepted' " class="d-flex align-items-center pt-md-3 pt-0 mt-md-3 mt-4">
               

                    <svg width="28" class='mr12' height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.5 12C15.464 12 13 14.463 13 17.5C13 20.537 15.464 23 18.5 23C21.535 23 24 20.537 24 17.5C24 14.463 21.535 12 18.5 12ZM11.866 21H0V1H22V10.866C21.38 10.538 20.708 10.294 20 10.15V3H13V9H9V3H2V19H11.15C11.294 19.708 11.538 20.38 11.866 21ZM17.885 18.06L16.626 16.878L15.664 17.867L17.904 20L21.669 16.166L20.69 15.196L17.885 18.06ZM9 17H4V15H9V17Z" fill="#0B0A23"/>
</g>
</svg>
                    <div class="pl-4" style="padding-left:20px">
                                          <p  style=" font-weight: 600;font-size: 15px;color: #8C8E9C;"  class=" ">To Be Delivered</p>

                       
                      
                    </div>
                   


                  </div>




</div>



      </div>
   
<div  class="pad25 d-md-none d-block">
  <div style="" class="" v-if=' actualorders!=null'> 
  




                  <div style="height: 1px;background:  rgba(231, 231, 246, 0.5);margin-bottom: 20px;"></div>
     
 
  </div>
 
</div>


 
</div>

  </div>

 
       <div class="col-md-4 mobcontainer" style="padding:0px;padding-left:10px">
        <div class="   rightcashbox rightpad " style="" >
 


  

      <div style="padding: 0 0px" class="mt-4">
 
    <div class="d-flex justify-content-between">
      <span  class="itmtxt itmtotaltxt"  >Item Total</span>
      <span class="itmtxt itmtxt1 " >₹{{rendertotal}}</span>
    </div>

 <div class="d-flex justify-content-between mt-3 ">
      <span   class="itmtxt deltxt">Delivery Fee</span>

  <span class="itmtxt" style="font-size:17px!important;color:#17b31b;font-family: 'Nunito', sans-serif;font-weight:600"  v-if="actualorders[0].deliveryamount!='Free'"  id="delcharge" data-delcharge=39>₹{{actualorders[0].deliveryamount}}</span>
       <span class="itmtxt" style="font-size:16px!important; font-family: 'Nunito', sans-serif;font-weight:600;color:#19B959" v-else id="delcharge" data-delcharge=39>{{actualorders[0].deliveryamount}}</span>


 
    </div>
 

 <div class="d-flex justify-content-between mt-3 " v-if='actualorders[0].couponapplied.status'>
      <span  class="itmtxt deltxt">Discount ({{actualorders[0].couponapplied.confirmedcouponcode}})</span>
       <span   id="delcharge" style="font-weight: 700;
font-size: 15px;
 font-family: 'Nunito', sans-serif;
color:#19B959;
text-align: right;

 "   >-₹{{actualorders[0].couponapplied.discountamount}}</span>
    </div>






<div style="" class="dashlinea"></div>


 
     <div class="d-flex justify-content-between   padt15  " style="  ">
      <span   style="font-size: 16px;font-weight:600;color: #0B0A23;">Total</span>


      <span   v-if="actualorders[0].deliveryamount!='Free' &&  actualorders[0].couponapplied.status"    style="font-weight: 500;font-size: 18px;text-align: right;color: #0B0A23;" id="totalpay">₹{{ actualorders[0].total+ actualorders[0].deliveryamount-Number(actualorders[0].couponapplied.discountamount)}}</span>
       <span   v-else-if="actualorders[0].deliveryamount!='Free' "    style="font-weight: 600;font-size: 18px;text-align: right;color: #0B0A23;"  id="totalpay">₹{{ actualorders[0].total}}</span>


         <span    v-else   style="font-weight: 600;font-size: 18px;text-align: right;color: #0B0A23;"  id="totalpay">₹{{ actualorders[0].total}}</span>

    </div>

</div>


 
         <div>
          <div style="height:1px;background:rgba(231, 231, 246, 0.5);margin-top: 10px; margin-bottom: 10px;margin-left:-24px;margin-right:-24px"></div>

 


          <div style="font-size:18px;font-weight:700;color:#0B0A23;margin-bottom:20px;margin-top:30px"  id="billdetails">Your Details</div>

    <div class="d-flex align-items-center mb-3">
      <div style="min-width: 105px;">
        <p style="" class="leftatt">Name:</p>
      </div>
      <p style="" class="rightatt">{{actualorders[0].name}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-3">
      <div style="min-width: 105px;">
        <p   class="leftatt">Mobile:</p>
      </div>
      <p  class="rightatt">{{actualorders[0].mobile}}</p>
      
    </div>
     <div class="d-flex align-items-start mb-3">
      <div style="min-width: 105px;">
        <p   class="leftatt">Address:</p>
      </div>
      <p  class="rightatt">{{actualorders[0].address}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-2">
      <div style="min-width: 105px;">
        <p   class="leftatt">City:</p>
      </div>
      <p class="rightatt" >{{actualorders[0].city}}</p>
      
    </div>
        </div>
        <div style="height:60px" class="d-md-none d-block"></div>













 



        </div>
      </div>
</div>
 










 



 
 </div>

  </div>
  
</div>
 
</div>

<div  v-else >



    <div  style="height:calc(100vh - 94px);background:#fff; " class=" d-none align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>




    <div  style="height:calc(100vh - 54px);background:#fff; " class="d-none align-items-center justify-content-center">
   
   <div style="width:80px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>





 

      </div>



 
 


 






 
 </div>

  
  </div>
</template>

<script>
 import firebase from 'firebase'
  import axios from 'axios'

 
const fb = require('./firebaseconfig.js')
 
export default {
 
        props: ['loadstatus','info','products','category','deals','addcart','test','carts','orders','theme','uids',],

  
  data () {

        return{
           query: "",
      selected: "",
      filteredOptions:[],
       sendotpclicked:false,
       otpenterd:true,
       otpvalue:'',
      mobilesearch:false,
      searching:false,
      opacitybox:false,
      suggestions: [
        {
          data: [
             
          ]
        }
      ], limit: 10,



            loaded:false,
            actualorder:null,
            user:false,
            singleorder:[],
            singdes:false,
              filters:[
            {
              name:'I ordered it by mistake',
              selected:true
            },
            {
              name:'I want to change my delivery address',
              selected:false,
            },
            {
              name:'Price for the product has decreased',
              selected:false,
            },
            {
              name:'I have changed my mind',
              selected:false,
            }, {
              name:'Other',
              selected:false,
            },
            ],


            auth:false,
            actloaded:false

        }
     
    
  },
  created(){
  var vm=this;

 
 if(firebase.auth().currentUser){

  this.auth=true
    this.user=true
 }else{
  this.auth=false
      this.user=false
 }


 
 

 
     fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('orders').where("orderid", "==", Number(vm.$route.params.orderid)).onSnapshot(querySnapshot=>{
 
    querySnapshot.forEach((doc)=> {
      
 
 
  vm.singdes=true
    vm.actloaded=true
    vm.singleorder.push({...doc.data()})

 axios.get('https://apiv2.shiprocket.in/v1/external/courier/track?order_id='+ doc.data().orderid, {
  headers: {
    'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjIwNTMxMTgsImlzcyI6Imh0dHBzOi8vYXBpdjIuc2hpcHJvY2tldC5pbi92MS9leHRlcm5hbC9hdXRoL2xvZ2luIiwiaWF0IjoxNjM2MjY4OTYzLCJleHAiOjE2MzcxMzI5NjMsIm5iZiI6MTYzNjI2ODk2MywianRpIjoiQk5LV21INXBkcW1aV0FnRCJ9.dXJSeLt-wCpMG5NrJeOuLX2IZACj5gt4Cyk8wrt0rgE'
  }
}).then((response)=>{
 
  console.log(response)
  
})



 



 

        
    })

  })



    this.singdes=false
 
 





 

   },
   methods:{  
    rendervarient(id,varients){

        var x=varients.filter((itm)=>{
          return itm.cart
        })

 
var data=''
          var y=x.forEach((itm,index)=>{
                  
                  if(index==x.length-1){
 data=data+itm.name 
                  }else{
                     data=data+itm.name+','
                  }
             

          })

        return data
    },
    logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 
vm.user=false
vm.$router.push({ path: '/'  })

}).catch(function(error) {
 
});
      },
    onSelected(item) {
 

 

 
  this.selected = item.item;
  this.opacitybox=false
 
 
 this.$router.push({ path: '/productsdetails/'+item.item.category+'/'+item.item.id })


   },
   removequery(){

      this.suggestions[0].data=[]

        this.filteredOptions = [{

         data:  []

        }];

this.searching=false
 
 this.query=''
   },
   async onInputChange(text) {

 
 

 

  this.suggestions[0]=[
  ]



        this.filteredOptions = [{
         data:   []
        }
        ];

 if(text.length>2){


 this.searching=true
const { docs } =   await fb.db.collection('adminportal').doc(this.uids).collection('products').where('searchableindex', 'array-contains',text.trim().toLowerCase()).limit(5).get()

   this.suggestions[0].data=[]

        this.filteredOptions = [{

         data:  []

        }];

 
 docs.map((doc) => {
 


 

  this.suggestions[0].data.push(doc.data());



        this.filteredOptions = [{
         data:   this.suggestions[0].data
        }
        ];



 });

 this.searching=false

      


 }
 

      
    },

    /**
     * This is what the <input/> value is set to when you are selecting a suggestion.
     */

    getSuggestionValue(suggestion) {
 

      return suggestion.item.name 
    },


    cancelorder(){

    
      this.$router.push({ path:  '/orderdetails/'+this.$route.params.orderid+'/cancel-order' })

    },


    account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    

    renderdate(timestamp){

      var date=timestamp.toDate();
      var stringdate=date.getDate()+'/'+date.getMonth()+'/'+date.getFullYear()
      var today=new Date()
      var stringtoday=today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear()
         var yesterday=new Date()
      yesterday.setDate(yesterday.getDate() - 1);


      var stringyesterdayday=yesterday.getDate()+'/'+yesterday.getMonth()+'/'+yesterday.getFullYear()
 
 
 

if(stringdate==stringtoday){
 
 return 'Today, '+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
 
}else if(stringyesterdayday==stringdate){

 return 'Yesterday, '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

   
}else{
return stringdate+', '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

}

     

    }

   },
   computed:{
 rendercartlength(){

var cartlength=0


        var x=this.actualorders[0].items.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
rendertotal(){
  var total=0
this.actualorders[0].items.forEach((itm)=>{

total=total+Number(itm.price)

})
return total
},
    actualorders(){

if(this.singdes){
 



 this.actualorder=this.singleorder.filter((item)=>{

      return item.orderid==this.$route.params.orderid
    })
 
  return this.actualorder

}else{

    return this.actualorder=this.orders.filter((item)=>{

      return item.orderid==this.$route.params.orderid
    })
    }
  }
   }

    
 
  
}
</script>
<style scoped >
  

</style>
 



// WEBPACK FOOTER //
// src/orderdetails.vue